<template>
    <div id="modal-embed" class="modal fade" role="dialog" data-backdrop="static">
        <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Insert Link</h4>
                </div>
                <div class="modal-body"> 
                    <input type="url" class="form-control" v-model="link" />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" data-dismiss="modal" @click="submitLink">Save &amp; Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['callback'], //readonly
    data() { //read and write
        return {
            link: ''
        }
    },
    methods: {
        submitLink() {
            this.callback(this.link);
            this.link = '';
        }
    },
}
</script>